export default {
  title: 'HiTeach课堂桌游',
  pvpGame: '摘星星',
  moleGame: '打地鼠',
  tfGame: '火箭升空',
  pickGame: '挑人转盘',
  punchBoardGame: '戳戳乐',
  moreManagement: '更多游戏管理',
  snakeGame: '贪食蛇',
  mazeGame: '闖迷宮',

  // 游戏说明标题
  gameInfoTitle: '游戏说明',
  close: '关闭',
  
  // 词汇掉落说明
  pvpGameTitle: '摘星星',
  pvpGameDesc: '在热带小岛上，词语像流星雨般从天而降！\n两位玩家要在限定时间内，抓住正确词语、闪避错误选项，谁能快速又精准地成为词汇猎人王？',
  
  // 打地鼠说明
  moleGameTitle: '打地鼠',
  moleGameDesc: '一人对战！知识版的打地鼠登场～\n地鼠们冒出头带来真假资讯，你能在最短时间内准确「敲」出正确答案，击退那些来搅乱的错误吗？',
  
  // 火箭升空说明
  tfGameTitle: '火箭升空',
  tfGameDesc: '准备升空，智慧对决启动！\n两位太空人面对是非题的挑战，答对才能让火箭直冲星际，答错就原地打转～谁能最先飞出大气层成为知识宇航员？',
  
  // 挑人转盘说明
  pickGameTitle: '挑人转盘',
  pickGameDesc: '转动命运的转盘！\n支持个人挑选、组别挑选或自订选项，让选择变得更有趣更公平。转盘旋转，答案揭晓！',
  
  // 戳戳乐说明
  punchBoardGameTitle: '戳戳乐',
  punchBoardGameDesc: '戳破惊喜的时刻！\n每个洞都藏着不同的惊喜，戳破表面探索内容。支持多种版面大小和动画效果，让选择充满期待！',

  // 更多游戏管理说明
  moreManagementTitle: '更多游戏管理',
  moreManagementDesc: '管理你的游戏设置与内容！\n在这里可以查看所有游戏的详细设置、管理游戏题目、调整游戏参数，让你的课堂游戏更加个性化和丰富！',

  // 贪食蛇说明
  snakeGameTitle: '贪食蛇',
  snakeGameDesc: '经典重现！知识版贪食蛇来袭～\n控制贪食蛇在迷宫中穿梭，吃到正确答案的食物让蛇身变长，小心不要撞到自己或墙壁！考验你的反应力与知识力！',

  // 迷宫说明
  mazeGameTitle: '闖迷宮',
  mazeGameDesc: '闖關冒險！智慧迷宮等你挑戰～\n在迷宮中尋找正確的路徑，最快找到出口的就是迷宮大師！',

  // 按钮文字
  play: '开始游戏',
  enterManagement: '进入管理',

  // 校园版授权警告
  schoolVersionWarning: '目前学校未取得校园版授权！',

  // 通用游戏设置（用于多个游戏）
  useHiTeachRoster: '使用 HiTeach 目前上课名单',
  rosterEmptyWarning: '目前名单为空，将使用预设匿名模式',

  // 推送相关
  pushSuccess: '推送成功',
  pushFailed: '推送失败：{message}',
  tokenRefreshing: '正在更新验证信息...',

  // 查看成绩相关
  viewScores: '查看成绩',
  noActivityPushed: '尚未推送活动，无法查看成绩',
  canViewScores: '推送成功！您可以点击查看成绩按钮查看学生提交的成绩',

  // 活动数量限制
  activityLimitExceeded: '已达活动数量上限（{maxLimit} 个），请至游戏管理删除部分活动后再试！'
}